angular.module('siter.io').directive 'strAutoFocus', ["$timeout", ($timeout) ->
  restrict: 'A',
  link: (scope, element) ->
    $timeout ->
      element[0].focus();
]



// WEBPACK FOOTER //
// ./src/app/common/directives/autofocus.coffee